import _isEmpty from 'lodash/isEmpty';
import _pickBy from 'lodash/pickBy';

export function filterOutInvalidFileData(fileData) {
  return _isEmpty(fileData) ? {} : _pickBy(fileData, (value) => !_isEmpty(value));
}
